import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { css } from '@emotion/react';

import { useIllustrationUrl } from '../../components/Illustrations/hooks/useIllustrationUrl.hook';
import { AddNotesIllustration } from '../../components/Illustrations/AddNotes/AddNotes';

import { Avatar } from '../../components/Avatar';
import { GatedButton } from '../../components/Access/GatedButton';
import type { AccessGate } from '../../components/Access/types/access-gate.type';

import { DEFAULT_REPORT_PLACEHOLDER_HEIGHT } from './constants/card.constant';

interface Props {
  readonly gate: AccessGate;
  readonly onStartCreate: () => void;
}

const NEW_REPORT_STRING = 'Initialiser un nouveau rapport';

export const CreateReportCard = ({
  gate,
  onStartCreate: handleStartCreate,
}: Readonly<Props>) => {
  const imageUrl = useIllustrationUrl(AddNotesIllustration);

  return (
    <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<Avatar icon={<PostAddIcon />} label={NEW_REPORT_STRING} />}
        css={css`
          .MuiCardHeader-action {
            display: contents;
          }
        `}
      />
      <CardMedia
        alt={NEW_REPORT_STRING}
        component="img"
        height={DEFAULT_REPORT_PLACEHOLDER_HEIGHT}
        image={imageUrl}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography color="text.secondary" variant="body1">
          {NEW_REPORT_STRING}
        </Typography>
      </CardContent>
      <CardActions>
        <GatedButton
          gate={gate}
          onClick={handleStartCreate}
          size="medium"
          variant="outlined"
        >
          Formulaire
        </GatedButton>
      </CardActions>
    </Card>
  );
};
